<template>
  <div class="base-background"/>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.base-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(../../assets/img/background-desktop.jpg);
  background-size: cover;
  background-position: center center;
  z-index: -1;
}
</style>
